import { buildAction } from 'store/actions/actionCreator'

import { FETCH_USER, FETCH_USER_ERROR, FETCH_USER_SUCCESS, PATCH_USER, SET_USE_LOCAL_CURRENCY } from './constants'

export const userError = buildAction(FETCH_USER_ERROR)

export const userSuccess = buildAction(FETCH_USER_SUCCESS, 'payload')

export const fetchUser = buildAction(FETCH_USER)

export const patchUser = buildAction(PATCH_USER, 'payload')

export const setUseLocalCurrency = buildAction(SET_USE_LOCAL_CURRENCY, 'payload')
